const introAnim = gsap.timeline({ paused: true });
introAnim.fromTo('.service-page-intro-wrapp .sec-header-content-anim-line', {
    x: 0,
    y: 49,
    z: -41,
    rotationX: -80,
    transformOrigin: '50% 0%',
    opacity: 0,
}, {
    x: 0,
    y: 0,
    z: 0,
    rotationX: 0,
    transformOrigin: '318px 30px',
    opacity: 1,
    stagger: 0.05,
    duration: 0.9,
    ease: 'power4.out'
})
ScrollTrigger.create({
    trigger: '.service-page-intro-wrapp',
    start: "0% 50%",
    end: '100% 60%',
    // markers: true,
    onEnter: () => introAnim.play(),
    onLeaveBack: () => introAnim.reverse()
})